import { invalidMapper, answeredMapper } from "../dashHelper";
import { commonWidgets } from "./commonWidgetsCaffenio";
import { getCommonWidget } from '../dashWidgetHelper'

const criticalMoment = 13905

export default {
  title: 'Satisfacción Dashboard',
  description: 'Satisfacción Default',
  widgets: (filters: FiltersUI) => [
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'lineDetailedByMonthAndGeo',
      title: "Satisfacción General",
      position: [0, 0],
      size: [4, 4],
      extraConfigs: {
        backgroundColor: 'transparent',
        theme: 'dark',
      },
      indicator: 'satisfacion_usa_pregunta_4',
      criticalMomentId: criticalMoment,
      extras: {
              formula: 'nps-10'
            }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'multipleTrendByMonth',
      title: 'Satisfacción General',
      position: [0, 4],
      size: [1, 2],
      indicator: 'satisfacion_usa_pregunta_4',
      criticalMomentId: criticalMoment,
      extras: {
        periods: 6,
        formula: 'nps-10'
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'multipleTrendByMonth',
      title: 'Recomedación',
      position: [1, 4],
      size: [1, 2],
      indicator: 'satisfacion_usa_pregunta_8',
      criticalMomentId: criticalMoment,
      extras: {
        periods: 6
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'multipleTrendByMonth',
      title: 'Recompra',
      position: [2, 4],
      size: [1, 2],
      indicator: 'satisfacion_usa_pregunta_7',
      criticalMomentId: criticalMoment,
      extras: {
        periods: 6
      }
    }),
    /*{
      title: "Productos",
      position: [3, 4],
      size: [1, 2],
      config: {
        id: "satisfaccion_pregunta_1",
        type: "pie",
        colors: ["#015c52", "#33b9ce", "#f38625", "#8bde26", "#f9b50b"],
        showHistoric: false,
        marginTop: 10,
        marginBottom: 20,
        marginLeft: 50,
        marginRight: 0,
        legendTop: 'top',
        itemDirection: "left-to-right",
        direction: "column",
        valueFormat: " >-.0%",
        center: ['40%', '65%'],
        radius: [25, 60],
        indicators: [
          {
            indicator: "satisfaccion_pregunta_1",
            keyExtract: ["group", "count", "value"],
            label: "group",
            value: "value",
            singleton: true,
            //grouped: "logicalLocation",
            extras: {
              useQuestionOptions: true,
              //groupByLevel: 1
            }
          }
        ]
      }
    },
    */
    /*getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGenericByStatus',
      title: '% Registros válidos para envío de encuestas',
      position: [3, 4],
      size: [1, 2],
      criticalMomentId: 10601,
      indicator: 'calidad-gauge',
      url: 'survey-responses/values',
      mapper: invalidMapper
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGenericByStatus',
      title: '% tasa de respuesta',
      indicator: 'venta-respuestas-gauge',
      url: 'survey-responses/values',
      mapper: answeredMapper,
      position: [0, 6],
      size: [1, 2],
      criticalMomentId: 10601,
    }),*/
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'mapByGeos',
      title: 'Mapa puntos de ventas',
      position: [0, 6],
      size: [2, 2],
      criticalMomentId: criticalMoment,
      extraConfigs: {
        bestLocationValueFrom: 90,
        worstLocationValueTo: 70
      },
      indicator: 'satisfacion_usa_pregunta_4',
    }),

    {
      title: "Verbalización",
      position: [2, 6],
      size: [2, 2],
      criticalMomentId: criticalMoment,
      config: {
        id: "word-count",
        type: "wordCloud",
        indicators: [
          {
            indicator: "WORD_COUNT",
            keyExtract: ["count", "value", "group"],
            singleton: true
          }
        ]
      }
    },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericSmall',
      title: "Programa MiCAFFENIO",
      position: [0, 8],
      size: [1, 3],
      indicator: 'satisfacion_usa_pregunta_3',
      extraConfigs: {
        showSample: false,
        colors: ["#f38625", "#8bde26", "#f9b50b"],
        showHistoric: false,
        marginTop: 10,
        marginBottom: 20,
        marginLeft: 50,
        marginRight: 0,
        legendTop: 'top',
        itemDirection: "left-to-right",
        direction: "column",
        valueFormat: " >-.0%",
        center: ['50%', '65%'],
        radius: [25, 60],
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'wordCountWithLinks',
      title: 'Nube de Palabras / Frecuencia en comentarios',
      position: [1, 8],
      size: [3, 3],
      criticalMomentId: criticalMoment,
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericMedium',
      title: '¿Por qué medio estas realizando tu compra?',
      position: [0, 11],
      size: [2, 2],
      indicator: 'satisfacion_usa_pregunta_2'
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericMedium',
      title: '¿Con qué atributo se relaciona su calificación anterior? ',
      position: [2, 11],
      size: [2, 2],
      extraConfigs: {
        itemGap: 10,
      },
      indicator: 'satisfacion_usa_pregunta_5'
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'textAnalysis',
      title: 'Analisis de Sentimientos',
      position: [0, 13],
      size: [4, 4],
      indicator: "SENTIMENT",
      criticalMomentId: criticalMoment
    }),
  ]
}
